import GridTile from "../grid/GridTile";

/**
 * @interface
 */
export default class ShadowCastCallback {
    /**
     * Invoked on a tile that is not in shadow.
     * @abstract
     * @param {GridTile} tile The tile.
     * @param {number} radius The radius from the center tile.
     * @param {number} lightFraction The fraction of the tile that is hit by light.
     */
    tileLighted(tile, radius, lightFraction) {}
}